import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';
import { CountryRiskUpdateCycles } from '../../../shared-models';
import { CellRendererLastUpdatedCustomParams } from '../models/cell-renderer-last-updated-custom-params.interface';

@Component({
  selector: 'grid-ui-cell-renderer-last-updated-info',
  templateUrl: './cell-renderer-last-updated-info.component.html',
  styleUrls: ['./cell-renderer-last-updated-info.component.scss'],
})
export class CellRendererLastUpdatedInfoComponent implements ICellRendererAngularComp {
  public lastEdition = '';
  public temporal = true;

  public iconName(): string {
    return this.temporal ? 'temporal' : 'atemporal';
  }

  public refresh(): boolean {
    return false;
  }

  public agInit(params: CellRendererLastUpdatedCustomParams): void {
    this.lastEdition = params.data.edition;
    this.temporal = params.data.update_cycle !== CountryRiskUpdateCycles.atemporal;
  }
}
